import '@images/favicon.ico';
import '@images/guide/background_pattern.jpg';
import '@images/guide/duck.jpg';
import '@images/guide/duck_large.jpg';
import '@images/404-bg.png';
import '@images/404-bg-mob.png';
import '@images/simple-bg.svg';
import '@images/breadcrumb-caret.svg';
import '@images/quote-dots.svg';
import '@images/featured-product-texture.svg';
import '@images/featured-product-texture-mob.svg';
import '@images/btn-arrow-right.svg';
import '@images/ext-link.svg';
import '@images/ext-link-hover.svg';
import '@images/ext-link-blue.svg';
import '@images/bg-modal-texture.svg';
import '@images/breadcrumb-arrow-white.svg';
import '@images/right-white-ext-link.svg';
